import { render, staticRenderFns } from "./AssignVehicle.vue?vue&type=template&id=b8271f72&scoped=true"
import script from "./AssignVehicle.vue?vue&type=script&lang=js"
export * from "./AssignVehicle.vue?vue&type=script&lang=js"
import style0 from "./AssignVehicle.vue?vue&type=style&index=0&id=b8271f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8271f72",
  null
  
)

export default component.exports